/**
 * Base das URLs de fotos (visitante/colaborador).
 * Mesmo padrão de dados-basicos / produtos: `urlFoto.caminhoFoto + path_image`
 * (ex.: path_image = "pessoa_img/68a4da951605e.png" → .../storage/pessoa_img/68a4da951605e.png).
 */
export const urlFoto = {
  caminhoFoto: process.env.VUE_APP_ROOT_STORAGE || "",
};
